export class GlobalCurrencyCurrency {
  idGlobalCurrency: number;
  idCurrency: number;

  constructor(
    idGlobalCurrency: number,
    idCurrency: number,
  ) {
    this.idGlobalCurrency = idGlobalCurrency;
    this.idCurrency = idCurrency;
  }

  static fromRaw(raw: any): GlobalCurrencyCurrency {
    return new GlobalCurrencyCurrency(
      raw.idGlobalCurrency,
      raw.idCurrency,
    );
  }

  clone(): GlobalCurrencyCurrency {
    return new GlobalCurrencyCurrency(
      this.idGlobalCurrency,
      this.idCurrency,
    );
  }

  toPayload(): any {
    return {
      idGlobalCurrency: this.idGlobalCurrency,
      idCurrency: this.idCurrency,
    };
  }
} 